import { render, staticRenderFns } from "./nSelect.vue?vue&type=template&id=74f2bf8b&"
import script from "./nSelect.vue?vue&type=script&lang=ts&"
export * from "./nSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports